import { createBrowserHistory } from "history";

let history = createBrowserHistory({ window });

export default history;
